import { useCallback, useEffect, useState } from "react";
import {
  addInterceptorsToServices,
  authenticateAuth0AndSaveUser,
  clearLocalStorageAuth,
  isMercuryGateUser,
} from "./utils/authUtils";
import LoadingSpinner from "./components/LoadingSpinner";
import MGTokenForm from "./features/mgTokenForm";
import APICallLog from "./features/apiCallLogs";
import AppHeader from "./components/appHeader/AppHeader";
import { Route, Switch, Redirect, NavLink } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

function App() {
  const [isPageLoading, setIsPageLoading] = useState(true);

  const {
    isAuthenticated,
    isLoading: isAuth0Loading,
    logout,
    loginWithRedirect,
    getIdTokenClaims,
    getAccessTokenSilently,
  } = useAuth0();

  const loginAuth0 = useCallback(async () => {
    if (isAuthenticated) {
      await addInterceptorsToServices(true, getAccessTokenSilently, logout);
      const claims = await getIdTokenClaims();
      const email = claims?.upn || claims?.email;
      await authenticateAuth0AndSaveUser(email);
      setIsPageLoading(false);
    } else {
      clearLocalStorageAuth();
      await loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [
    isAuthenticated,
    loginWithRedirect,
    getAccessTokenSilently,
    logout,
    getIdTokenClaims,
  ]);

  useEffect(() => {
    if (!isAuth0Loading) {
      const startAuth = async () => {
        await loginAuth0();
      };
      startAuth();
    }
  }, [isAuth0Loading, isPageLoading, loginAuth0]);

  if (isPageLoading) {
    return <LoadingSpinner size="30" />;
  }

  return (
    <>
      <AppHeader isAuth0Enabled={true}>
        {isMercuryGateUser() && (
          <>
            <NavLink
              to="/tokenGeneration"
              className="navItem"
              activeClassName="active"
            >
              Token Generation
            </NavLink>
            <NavLink
              to="/apiCallLog"
              className="navItem"
              activeClassName="active"
            >
              API Call Log
            </NavLink>
          </>
        )}
      </AppHeader>
      <Switch>
        <Route path="/tokenGeneration" component={MGTokenForm}></Route>
        <Route path="/apiCallLog" component={APICallLog}></Route>
        <Redirect from="/" to="/tokenGeneration" />
      </Switch>
    </>
  );
}

export default App;
